import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import rpGuiGuide from 'rp-gui-guide';
import rpPopup from 'rp-popup';
import { cleanLegacy } from 'rp-cookie';
import initCardsUrlSettings from 'rp-url-navigation-prefs';
import rpAdvertising from 'rp-advertising';
import { appPromo } from 'rp-navigation';

import 'rp-gui-guide/dist/css/rpguiguide.min.css';
import 'rp-advertising/dist/rpadvertising.min.css';

import 'rp-betting-special-offer/src/scss/main.scss';

import 'rp-prices-component/dist/css/rppricecomponent.min.css';

import App from './App';
import configureStore from './configureStore';
import '../css/main.scss';

import analyticsPage from './analyticsPage';

analyticsPage();
/**
 * Clean-up legacy cookies
 */
cleanLegacy();
/**
 * Initialize gui-guide scripts
 */
rpGuiGuide({
    svg: { polyfill: true }
});
/**
 * Initialize popup component
 */
rpPopup();
/**
 * Initialize navigation cards preferences
 */
initCardsUrlSettings();

const homepageContainer = document.getElementById('homepageId');

/**
 * Render react application to root element
 *
 * Renders only for Homepage and Content Hub routes.
 * Inits Ads component only for cookie-policy route.
 */
if (homepageContainer) {
    render(
        <Provider store={configureStore()}>
            <App />
        </Provider>,
        homepageContainer
    );
} else {
    rpAdvertising();
}
/**
 * show appPromo banner after page content is loaded
 */
appPromo.init();



// WEBPACK FOOTER //
// ./src/js/index.js